import { IFavoriteProfessional, IFavoriteProfessionalApi } from './favoriteProfessionalsTypes';

function toFavoriteProfessional(businessApi: IFavoriteProfessionalApi): IFavoriteProfessional {
  return {
    id: businessApi.id,
    fullName: businessApi.fullname,
    activityLevel: businessApi.activityLevel,
    averageProfessionalRating: businessApi.averageProfessionalRating,
    isAvailable: businessApi.isAvailable,
    professions: businessApi.professions,
    profileImage: businessApi.profileImage,
  };
}

export const favoriteProfessionalsAdapter = { toFavoriteProfessional };
